module.exports = __webpack_public_path__ + "c9dfaa4a310f10ef2a6c1cf6650b1ffb.jpg";